import StoreBase from './base'
import { objectToGet } from '../functions'

// import Const from '../const/index'
// import Collection from '../service/_collection'

/**
 * UiStore // UIのデータを格納するstore
 *
 * @extends {StoreBase}
 */
class UiStore extends StoreBase {
  constructor() {
    super()
    this.store = {
      // example: {
      //   data: null,
      // },
    }
  }

  /**
   * init // 変数の動的な初期化
   *
   * @param {object} data
   */
  init(data) {
    Object.keys(data).forEach(value => {
      this.addUi(value, data[value])
    })
    this.trigger('Ui')
  }

  /**
   * addUi. // 一個ずつ設定する
   *
   * @param {string} name
   * @param {object} formData
   */
  addUi(name, formData) {
    this.set(name, formData)
  }

  /**
   * updateData. // 値を更新する
   *
   * @param {string} name
   * @param {any} value
   * @param {boolean} clearFlg
   */
  updateData(name, value, clearFlg = false) {
    if (clearFlg) this.store[name] = null
    this.set(name, value)
    this.trigger(`Ui:${name}`)
  }

  /**
   * getData.
   *
   * @param {string} name
   * @param {any} defaultValue
   * @param {string} path
   */
  getData(name, defaultValue = null, path = null) {
    const data = this.state(`${name}`, null)
    if (data === null) return defaultValue
    if (path !== null) {
      return objectToGet(data, path, defaultValue)
    }
    return data
  }

  /**
   * func.// データに対して関数を実行する
   *
   * @param {function} func
   *
   * @return {any}
   */
  func(func) {
    const data = { ...this.store }
    return func(data)
  }
}

export default new UiStore()
